import React, { useMemo } from 'react'
import IGMedia from './deliverables/IGMedia'
import FormContentApproval from './deliverables/FormContentApproval'
import { MilestoneStep } from 'types/collaboration'

interface DeliverablesPreviewProps {
    step: MilestoneStep,
    setSelectedMedia: (media: any) => void
}

const DeliverablesPreview: React.FC<DeliverablesPreviewProps> = ({ step, setSelectedMedia }) => {

    return (
        <div>
            {
                ['reel_approval', 'post_approval', 'story_approval', 'ig_media_approval', 'video_approval'].includes(step.gig_step.slug) ?
                    (<IGMedia mediaType={step.gig_step.attributes.media_product_type} milestoneStep={step.gig_step.slug === 'ig_media_approval' ? null : step.gig_step.slug} />)
                    :
                    (<FormContentApproval setSelectedMedia={setSelectedMedia} properties={step.gig_step.properties} />)
            }

        </div>
    )
}

export default DeliverablesPreview